module.exports = __webpack_public_path__ + "img/store.f569d2d2.svg";